import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  cancelBooking: {
    marginRight: 15,
    width: 130,
  },
  serviceIcon: {
    alignSelf: 'center',
    marginTop: 50,
  },
  serviceTitle: {
    marginTop: 40,
    alignSelf: 'center',
    width: '80%',
  },
  storeContainer: theme => ({
    width: '100%',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: theme.colors.shimmerBorder,
    height: 125,
    marginVertical: 30,
  }),

  storeIcon: {
    marginLeft: 20,
  },
  storeDetails: {
    marginLeft: 12,
    height: 15,
    width: '75%',
    marginTop: 10,
    top: -5,
  },
  date: {
    alignSelf: 'center',
    width: '80%',
    marginBottom: 50,
  },
  changeBookingBtn: {
    width: '50%',
    marginRight: 5,
    height: 30,
  },
  storeDirectionBtn: {
    width: '50%',
    marginLeft: 5,
    height: 30,
  },
})
